"use strict";

exports.__esModule = true;
exports["default"] = exports.StepsBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _glyph = _interopRequireDefault(require("../glyph"));

var _progressBar = _interopRequireDefault(require("../form-ui/progress-bar"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var IndicatorContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "progress-indicator__IndicatorContainer",
  componentId: "sc-1j70ghv-0"
})(["position:relative;"]);
var IndicatorIcon = (0, _styledComponents["default"])(_glyph["default"]).withConfig({
  displayName: "progress-indicator__IndicatorIcon",
  componentId: "sc-1j70ghv-1"
})(["height:16px;width:16px;"]);
var StepsBox = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "progress-indicator__StepsBox",
  componentId: "sc-1j70ghv-2"
})(["position:absolute;border-radius:50%;", " ", ";left:", "%;transform:translateX(-50%);"], (0, _styles.defaultTransition)(["box-shadow", "background"]), function (props) {
  return props.hasShadow ? (0, _styledComponents.css)(["box-shadow:0 2px 5px 3px ", ";"], (0, _styles.themeTransparentize)(props.currentStep ? 0.9 : 0.95, "shadow", props)) : (0, _styledComponents.css)(["box-shadow:0 2px 5px 3px ", ";"], (0, _styles.themeTransparentize)(1, "shadow", props));
}, function (_ref) {
  var position = _ref.position;
  return Math.round(100 * position);
});
exports.StepsBox = StepsBox;
var propTypes = {
  /** progress - number between 0 - steps used to show status */
  progress: _propTypes.number,

  /** steps - number used to show number of steps */
  steps: _propTypes.number
};
var defaultProps = {
  progress: 0,
  steps: 3
};

var ProgressIndicator = function ProgressIndicator(_ref2) {
  var progress = _ref2.progress,
      steps = _ref2.steps;
  return /*#__PURE__*/_react["default"].createElement(IndicatorContainer, {
    alignItems: "center",
    height: 32,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_progressBar["default"], {
    barColor: "background-selected",
    progress: (progress - 1) / (steps - 1)
  }), (0, _ramda.is)(Number, steps) && (0, _ramda.times)(function (index) {
    var step = index + 1;
    return /*#__PURE__*/_react["default"].createElement(StepsBox, {
      key: index,
      alignItems: "center",
      backgroundColor: progress > step ? "background-selected" : "background",
      currentStep: progress === step,
      hasShadow: progress <= step,
      height: 32,
      justifyContent: "center",
      position: (step - 1) / (steps - 1),
      width: 32
    }, progress > step ? /*#__PURE__*/_react["default"].createElement(IndicatorIcon, {
      fill: "background",
      id: "check"
    }) : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
      color: progress === step ? "text-title" : "background-light",
      fontWeight: 600,
      textAlign: "right"
    }, _utils.defaultFontSize), step));
  }, steps));
};

ProgressIndicator.propTypes = propTypes;
ProgressIndicator.defaultProps = defaultProps;
ProgressIndicator.displayName = "Modules.ProgressIndicator";
var _default = ProgressIndicator;
exports["default"] = _default;